import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimConnectivityComponent } from './anim-connectivity/anim-connectivity.component';
import { AnimEdcComponent } from './anim-edc/anim-edc.component';
import { AnimSixComponent } from './anim-six/anim-six.component';
import { AnimInternetComponent } from './anim-internet/anim-internet.component';
import { AnimDwdmComponent } from './anim-dwdm/anim-dwdm.component';
import { AnimBackboneComponent } from './anim-backbone/anim-backbone.component';
import { AnimPopcoverageComponent } from './anim-popcoverage/anim-popcoverage.component';
import { AnimTelecomComponent } from './anim-telecom/anim-telecom.component';
import { AnimTopologyComponent } from './anim-topology/anim-topology.component';

@NgModule({
  declarations: [
    AnimConnectivityComponent,
    AnimEdcComponent,
    AnimSixComponent,
    AnimInternetComponent,
    AnimDwdmComponent,
    AnimBackboneComponent,
    AnimPopcoverageComponent,
    AnimTelecomComponent,
    AnimTopologyComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AnimConnectivityComponent,
    AnimEdcComponent,
    AnimSixComponent,
    AnimInternetComponent,
    AnimDwdmComponent,
    AnimBackboneComponent,
    AnimPopcoverageComponent,
    AnimTelecomComponent,
    AnimTopologyComponent
  ]
})
export class AnimationModule { }
